import { Link } from 'react-router-dom';
import { useTrip } from '../lib/tripContext.jsx';

export default function Header() {
  const { trip } = useTrip();

  return (
    <header
      className="sticky top-0 z-20 border-b border-border-tertiary bg-bg-primary/90 backdrop-blur"
      style={{ paddingTop: 'var(--safe-top)' }}
    >
      <div className="flex h-12 items-center justify-between px-4">
        <Link to="/" className="flex items-baseline gap-2">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-fg-tertiary">
            some say
          </span>
          <span className="text-sm font-medium text-fg-primary">{trip?.name || ''}</span>
        </Link>
        <Link
          to="/sos"
          aria-label="Emergency SOS"
          className="flex h-9 items-center gap-1.5 rounded-full border border-danger/40 bg-danger/10 px-3 font-mono text-xs uppercase tracking-wider text-danger transition hover:bg-danger/15"
        >
          <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-danger" />
          SOS
        </Link>
      </div>
    </header>
  );
}
